import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

const ZendeskCloseButton = (props) => {
  const dispatch = useDispatch();
  const navigate = useHistory()
  const location = useLocation();

  const [showWidget, setShowWidget] = useState(true)

  useEffect(() => {
    setShowWidget(true)

    if (location) {
      const pathname = location.pathname
      if (pathname === "/geofences") {
        setShowWidget(false)
      }
      else if (pathname === "/trip_access") { //static shared page
        setShowWidget(false)
      }
      else if (pathname.includes("/temporary/") || pathname.includes("/temporary-map/") || pathname.includes("/temporary-replay/")) { // temporary shared pages
        setShowWidget(false)
      }
      else if (pathname.includes("/facility/")) { //shuttle page
        setShowWidget(false)
      }
      else {
        setShowWidget(true)
      }
    }
  }, [location, navigate]);

  const handleClose = () => {
    if (window.zE) {
      setShowWidget(!showWidget)
    }
  };

  useEffect(() => {
    if (window.zE) {
      if (showWidget) {
        window.zE('webWidget', 'show');
      } else {
        window.zE('webWidget', 'hide');
      }
    }
  }, [showWidget])

  return (
    <>
      {
        showWidget ? (
          <>
            <button
              onClick={() => handleClose()}
              style={{
                position: "fixed",
                bottom: "65px",         // match Zendesk position
                right: "20px",          // just left of Zendesk button (~70px wide)
                zIndex: 999998,
                background: "#ff4d4f",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                fontSize: "18px",
                cursor: "pointer",
                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                transitionDuration: '250ms',
                transitionTimingFunction: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
                transitionProperty: 'opacity, top, bottom'
              }}
              title="Hide Zendesk Widget"
            >
              ×
            </button>
          </>
        ) : (
          <></>
        )
      }
    </>
  );
};

export default ZendeskCloseButton;
